import {
  STORE_PLAN_CATALOG,
  PLAN_CATALOG_LOADING,
  STORE_PLAN_CATALOG_PREVIEW,
} from '../../constants/planCatalog';

const initialState = {
  // The whole /planCatalog/overview payload: catalog, the fixed feature
  // list, per-plan company counts, queued rollouts, custom rates, history.
  overview: null,
  loading: false,
  preview: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case STORE_PLAN_CATALOG:
      return { ...state, overview: action.overview, loading: false };
    case PLAN_CATALOG_LOADING:
      return { ...state, loading: !!action.loading };
    case STORE_PLAN_CATALOG_PREVIEW:
      return { ...state, preview: action.preview };
    default:
      return state;
  }
};
